import { Component, ElementRef, EventEmitter, Inject, Output, Renderer2, ViewChild } from '@angular/core';
import { EventsService } from '../../services/events/events.service';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { DOCUMENT} from '@angular/common';
import { OrderService } from '../../services/Order/order.service';
import { ApiService } from '../../services/API/api.service';
import { ScrollService } from '../../services/Scroll/scroll.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-receipt-method',
  templateUrl: './receipt-method.component.html',
  styleUrls: ['../../../../assets/styles/global/_card.css', 'receipt-method.component.css']
})
export class ReceiptMethodComponent {
  @ViewChild('offCanva') offCanva!: ElementRef;
  step: boolean = false;
  company!: Company;
  openModalScheduling: boolean = false;
  selectedOption: { checked: boolean, value: number } = { checked: false, value: 0};
  @Output() optionSelected: EventEmitter<{ checked: boolean, value: number}> = new EventEmitter<{ checked: boolean, value: number}>();
  @Output() scheduleSelected: EventEmitter<{checked: boolean, value: any}> = new EventEmitter<{checked: boolean, value: any}>();
  schedulingHours: any[] = [];
  timeSelected: any;
  timeSelectedVariable: any;
  dateServer: string = '';
  preparationTime: string = '';

  offCanvasHeight: string | number = 'auto';
  initHeight: number = 0;
  private startY = 0;
  private isDragging = false;
  hiddenButton: boolean = false;

  constructor(
    private eventsService: EventsService,
    private connection: ConnectionService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private orderService: OrderService,
    private apiService: ApiService,
    private scrollService: ScrollService,
    private cdr: ChangeDetectorRef,
  ){
    this.connection.company$.subscribe((newCompany) =>{
      this.company = newCompany;
    })
  }

  ngOnInit(): void {
    this.getDateServer();

    if(this.selectedOption.checked == false)
    {
      this.step = true;
    }
  }

  verifiSchedule(){
    if(this.company.configs.scheduling == 1) {
      const now = new Date(this.dateServer);
      const hours = now.getHours()
      const minutes = now.getMinutes()
      const time = `${hours}:${minutes}`

      if(this.company.configs.preparationTime < 60) {
        this.preparationTime = `00:${this.company.configs.preparationTime}`
      }
      else if(this.company.configs.preparationTime == 60) {
        this.preparationTime = '01:00'
      }

      this.company.configs.schedulingDays.times.forEach((item: any, index: number) => {
        if((this.paraMinutos(item.start) - this.paraMinutos(this.preparationTime)) > this.paraMinutos(time)) {
          this.schedulingHours.push(item);
        }
      });

      if(this.schedulingHours.length == 0){
        setTimeout(() => {
          this.onCheckboxChange({checked: true, value: 2 })
        }, 10);
      }
      else{

        if(!this.orderService.pedidoAtual.scheduled && this.orderService.pedidoAtual.typeScheduled == 2){
          this.onCheckboxChange({checked: true, value: 2 })
        }
        else if(this.orderService.pedidoAtual.scheduled && this.orderService.pedidoAtual.typeScheduled == 1){

          if((this.paraMinutos(this.orderService.pedidoAtual.times.start) - this.paraMinutos(this.preparationTime)) < this.paraMinutos(time)) {
            this.orderService.pedidoAtual.times = this.schedulingHours[0];
          }

          this.onCheckboxChange({checked: true, value: 1 })
          if(this.company.configs.closeScheduling == 1 && this.company.company.status == 0){
            setTimeout(() => {
              this.hiddenButton = true;
            }, 10);
            
          }
        }
        else{
          if(this.company.configs.closeScheduling == 1 && this.company.company.status == 0){
            this.onCheckboxChange({checked: true, value: 1 })
            setTimeout(() => {
              this.hiddenButton = true;
            }, 10);
          }
        }
      }
    }
    else{
      this.onCheckboxChange({checked: true, value: 2 })
    }
  }

  paraMinutos(horaStr: string) {
    const [h, m] = horaStr.split(':').map(Number);
    return h * 60 + m;
  }

  //Desabilita o scroll da pagina
  disableScroll(){
    this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
  }

  //Habilita o scroll da pagina
  enableScroll(){
    this.renderer.removeStyle(this.document.body, 'overflow');
  }

  onCheckboxChange(data: { checked: boolean, value: number}) {
    this.selectedOption = data;
    this.optionSelected.emit(this.selectedOption);

    if(!this.orderService.pedidoAtual.times){
      if(data.value == 1) {
        this.timeSelected = {checked: true, value: this.schedulingHours[0]}
        this.timeSelectedVariable = this.timeSelected
      }

      if(this.timeSelected) {
        this.confirmHour();
      }
    }
    else{
      if(data.value == 1) {
        this.timeSelected = {checked: true, value: this.orderService.pedidoAtual.times}
        this.timeSelectedVariable = this.timeSelected
      }

      if(this.timeSelected) {
        this.confirmHour();
      }
    }

  }

  changeButton(){    
    this.selectedOption.checked = false;
    this.selectedOption.value = 0
    this.optionSelected.emit({ checked: false, value: 0 });
    this.scheduleSelected.emit({ checked: false, value: 0 });
    this.eventsService.eventTypeReceipt = 0
  }

  hourselected(data: { checked: boolean, value: any}){
    this.timeSelectedVariable = data;
  /*   this.scheduleSelected.emit(data); */
  }

  getDateServer(){
    this.apiService.getHours().subscribe(
      (data) =>{
        setTimeout(() => {
          this.dateServer = data.date;
          this.verifiSchedule();
        });

        // this.cdr.detectChanges();
      },
      (error) =>{
        console.log(error);
      }
    )
  }

  confirmHour(){
    this.timeSelected = this.timeSelectedVariable
    this.scheduleSelected.emit(this.timeSelected);
    this.openModalScheduling = false;
    this.enableScroll()
  }

  openCanva(){
    this.offCanvasHeight = this.offCanva.nativeElement.offsetHeight;
    this.initHeight = Number(this.offCanvasHeight)
    this.scrollService.disableScroll();
    this.openModalScheduling = true;
  }


  //Quando o usuario clica
  onTouchStart(event: TouchEvent) {
    this.startY = event.touches[0].clientY;
    this.isDragging = true;
  }

  // Quando o usuario arrasta
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;

    const currentY = event.touches[0].clientY;
    const deltaY = currentY - this.startY;

    if (deltaY > 0) {
      this.offCanvasHeight = Math.max(0, this.initHeight - deltaY);
    }
  }

  // Finalizar o toque
  onTouchEnd() {
    this.isDragging = false;

    // Fechar se a altura for pequena
    if (Number(this.offCanvasHeight) < 50) {
      this.closeOffCanvas();
    } else {
      this.offCanvasHeight = this.initHeight; // Resetar altura
    }
  }

  closeOffCanvas() {
    this.openModalScheduling = false;
    this.offCanvasHeight = this.initHeight;

    setTimeout(() => {
      this.scrollService.enableScroll();
    }, 500);
  }
}
